import { TipoDeRecurso } from '@/models/Recurso'
import { tituloDaToolbarPeloNomeDaRota } from '@/shareds/router-shareds'
import { RouteConfig } from 'vue-router'

const rotasDeRegrasFiscais: RouteConfig[] = [
	{
		path: 'regra-fiscal',
		name: 'Regras Fiscais',
		components: {
			default: () => import('@/views/application/configuracoes/fiscal/TelaDeRegrasFiscais.vue'),
			toolbar: () => import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: { toolbar: tituloDaToolbarPeloNomeDaRota },
		meta: {
			recurso: 'regras-fiscais' as TipoDeRecurso,
		},
	},
]

export default rotasDeRegrasFiscais